import { jsx as _jsx } from "react/jsx-runtime";
var Star = function Star(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M17.562 21c-.158 0-.317-.036-.463-.112l-5.1-2.664-5.097 2.664a1.002 1.002 0 0 1-1.448-1.057l.97-5.628-4.12-3.985a1.001 1.001 0 0 1 .553-1.708l5.7-.828 2.548-5.126c.338-.68 1.453-.68 1.79 0l2.549 5.126 5.7.828a.998.998 0 0 1 .552 1.708l-4.12 3.985.97 5.628a1 1 0 0 1-.984 1.17Z",
      fill: color
    })
  });
};
export default Star;